import { render, staticRenderFns } from "./bindEmail.vue?vue&type=template&id=6e47ea6c&scoped=true&"
import script from "./bindEmail.vue?vue&type=script&lang=js&"
export * from "./bindEmail.vue?vue&type=script&lang=js&"
import style0 from "./bindEmail.vue?vue&type=style&index=0&id=6e47ea6c&prod&scoped=true&lang=less&"
import style1 from "./bindEmail.vue?vue&type=style&index=1&id=6e47ea6c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e47ea6c",
  null
  
)

export default component.exports